import { ModelBase } from "pytha";
import { graphicStore } from "../store/graphic-store";
import { OrthographicCamera } from "three";

export const showEntity = (models: ModelBase[]) => {
    if (!models || models.length == 0) {
        return;
    }

    let x1 = +Infinity
    let y1 = +Infinity
    let x2 = -Infinity
    let y2 = -Infinity

    models.forEach(model => {
        let box = model.getBoundingBox();
        box.min.project(graphicStore.extraContext.getCurrentViewEditor().camera);
        box.max.project(graphicStore.extraContext.getCurrentViewEditor().camera);
        x1 = Math.min(box.min.x, x1);
        y1 = Math.min(box.min.y, y1);
        x2 = Math.max(box.max.x, x2);
        y2 = Math.max(box.max.y, y2);
    })

    if (x1 == null || y1 == null || x2 == null || y2 == null) {
        return
    }

    let scale1 = Math.abs(y1 - y2) / 2;

    let scale2 = Math.abs(x1 - x2) / 2;
    // max
    let scale = Math.max(scale1, scale2) * 2;
    let x = (x1 + x2) / 2;
    let y = (y1 + y2) / 2;
    let camera = graphicStore.extraContext.getCurrentViewEditor().camera;
    let target = graphicStore.context.ucsContext.unprojectCursorPoint(x, y, camera);

    let lastTarget = graphicStore.extraContext.getCurrentViewEditor().viewControl.target.clone();
    let offset = camera.position.clone().sub(lastTarget);
    const position = camera.position;
    graphicStore.extraContext.getCurrentViewEditor().viewControl.target.copy(target);
    position.copy(target).add(offset);
    graphicStore.extraContext.getCurrentViewEditor().camera.lookAt(target);
    // scale 框和当前边界的比例
    graphicStore.context.renderContext.cameraEdge *= scale;
    if (camera.type === "OrthographicCamera") {
        let orthoCamera = camera as OrthographicCamera;
        orthoCamera.left = orthoCamera.left * scale;
        orthoCamera.right = orthoCamera.right * scale;
        orthoCamera.top = orthoCamera.top * scale;
        orthoCamera.bottom = orthoCamera.bottom * scale;
        orthoCamera.updateProjectionMatrix();
    }


    graphicStore.extraContext.listeners.signals.onZoomChanged.dispatch(1 / scale);
}